"use client";

import { useEffect, useState } from "react";

const QUERY = "(hover: hover)";

/**
 * Whether the primary pointing device can hover, per the `hover` media feature.
 * Returns `false` during SSR and on touch devices, where hover-revealed controls
 * are unreachable and a gesture must carry the affordance instead.
 */
export const useCanHover = (): boolean => {
  const [canHover, setCanHover] = useState(typeof window !== "undefined" ? window.matchMedia(QUERY).matches : false);

  useEffect(() => {
    const media = window.matchMedia(QUERY);
    setCanHover(media.matches);

    const onChange = (event: MediaQueryListEvent) => setCanHover(event.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return canHover;
};
